import * as React from "react";
import { SVGProps } from "react";
export const Chevron2RightIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        width="1em"
        height="1em"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M4.05516 17.458L10.9932 10.521C11.0898 10.4237 11.1592 10.323 11.2012 10.219C11.2432 10.115 11.2642 10.0073 11.2642 9.896C11.2642 9.78467 11.2432 9.677 11.2012 9.573C11.1592 9.469 11.0898 9.36833 10.9932 9.271L4.03416 2.313C3.82616 2.10433 3.57283 2 3.27416 2C2.97549 2 2.72216 2.11133 2.51416 2.334C2.29149 2.542 2.18716 2.79867 2.20116 3.104C2.21516 3.41 2.32616 3.667 2.53416 3.875L8.55516 9.896L2.51416 15.938C2.31949 16.132 2.22216 16.3853 2.22216 16.698C2.22216 17.0107 2.31949 17.264 2.51416 17.458C2.72216 17.6667 2.97883 17.771 3.28416 17.771C3.59016 17.771 3.84716 17.6667 4.05516 17.458Z"
            fill="currentColor"
        />
        <path
            d="M10.5552 17.458L17.4932 10.521C17.5898 10.4237 17.6592 10.323 17.7012 10.219C17.7432 10.115 17.7642 10.0073 17.7642 9.896C17.7642 9.78467 17.7432 9.677 17.7012 9.573C17.6592 9.469 17.5898 9.36833 17.4932 9.271L10.5342 2.313C10.3262 2.10433 10.0728 2 9.77416 2C9.47549 2 9.22216 2.11133 9.01416 2.334C8.79149 2.542 8.68716 2.79867 8.70116 3.104C8.71516 3.41 8.82616 3.667 9.03416 3.875L15.0552 9.896L9.01416 15.938C8.81949 16.132 8.72216 16.3853 8.72216 16.698C8.72216 17.0107 8.81949 17.264 9.01416 17.458C9.22216 17.6667 9.47883 17.771 9.78416 17.771C10.0902 17.771 10.3472 17.6667 10.5552 17.458Z"
            fill="currentColor"
        />
    </svg>
);
Chevron2RightIcon.displayName = "Chevron2RightIcon";
